import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { ListItem, ListItemButton, ListItemText, useTheme } from '@mui/material';
import { type RefObject, useState } from 'react';
import { Episodes } from './Episodes.tsx';
import { type SeasonData } from './types.ts';

export type SeasonProps = SeasonData & {
  onEpisodeClick: (season: number, episode: number) => void;
  selected: boolean;
  selectedEpisodeNumber: number;
  selectedEpisodeRef: RefObject<HTMLLIElement | null>;
};

export const Season = ({
  episodes,
  id,
  onEpisodeClick,
  seasonNumber,
  selected,
  selectedEpisodeNumber,
  selectedEpisodeRef,
}: SeasonProps) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(true);

  return (
    <ListItem disablePadding key={id} sx={{ flexDirection: 'column' }}>
      <ListItemButton
        onClick={() => {
          setExpanded(!expanded);
        }}
        sx={{
          ':hover': {
            backgroundColor: theme.palette.grey[900],
          },
          backgroundColor: theme.palette.grey[900],
          borderBottom: '1px solid',
          borderBottomColor: theme.supportingTextSecondary,
          boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2)',
          color: theme.supportingTextSecondary,
          flexGrow: 0,
          maxHeight: '49px',
          paddingTop: theme.spacing(2),
          position: 'sticky',
          top: 0,
          width: '100%',
          zIndex: 1,
        }}
      >
        <ListItemText primary={`Season ${String(seasonNumber)}`} />
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      {expanded ? (
        <Episodes
          episodes={episodes}
          onEpisodeClick={onEpisodeClick}
          seasonNumber={seasonNumber}
          seasonSelected={selected}
          selectedEpisodeNumber={selectedEpisodeNumber}
          selectedEpisodeRef={selectedEpisodeRef}
        />
      ) : undefined}
    </ListItem>
  );
};
